import { FC } from 'react';
import { useFragment, graphql } from 'react-relay';

import {
    REGULAR_MODULE_TYPE,
    BANNER_MODULE_TYPE,
    BANNER_TILES_MODULE_TYPE,
} from '../../constants/contentModuleConstants';
import { pageTypeConstants } from '../../constants/pageTypeConstants';

import { SbRespContentModuleRegular } from '../SbRespContentModuleRegular/SbRespContentModuleRegular';
import { SbSharedContentModuleBanner } from '../SbSharedContentModuleBanner/SbSharedContentModuleBanner';
import { SbSharedContentModuleBannerTiles } from '../SbSharedContentModuleBannerTiles/SbSharedContentModuleBannerTiles';

import { SbRespContentModuleSelector_itemSearch$key } from './__generated__/SbRespContentModuleSelector_itemSearch.graphql';

type Props = {
    itemSearch: SbRespContentModuleSelector_itemSearch$key;
    className?: string;
    hidePhoto: boolean;
};

export const SbRespContentModuleSelector: FC<Props> = ({
    itemSearch: itemSearchRef,
    className,
    hidePhoto,
}) => {
    const itemSearch = useFragment(
        graphql`
            fragment SbRespContentModuleSelector_itemSearch on ItemSearchQueryConnection {
                pageType
                browseContentModule(contentModuleId: $contentModuleId) {
                    moduleType
                    ...SbRespContentModuleRegular_browseContentModule
                    ...SbSharedContentModuleBanner_browseContentModule
                    ...SbSharedContentModuleIconicDesign_browseContentModule
                    ...SbSharedContentModuleBannerTiles_browseContentModule
                }
            }
        `,
        itemSearchRef
    );

    const { browseContentModule, pageType } = itemSearch || {};
    const isSalePage = pageType === pageTypeConstants.SALE;

    if (!browseContentModule) {
        return null;
    }

    switch (browseContentModule.moduleType) {
        case REGULAR_MODULE_TYPE:
            return (
                <SbRespContentModuleRegular
                    browseContentModule={browseContentModule}
                    hidePhoto={hidePhoto}
                    className={className}
                />
            );
        case BANNER_MODULE_TYPE:
            return (
                <SbSharedContentModuleBanner
                    browseContentModule={browseContentModule}
                    renderImage={({ src, imgClassName, alt }) => (
                        <img src={src} className={imgClassName || ''} alt={alt || ''} />
                    )}
                />
            );
        case BANNER_TILES_MODULE_TYPE:
            return (
                <SbSharedContentModuleBannerTiles
                    browseContentModule={browseContentModule}
                    isSalePage={isSalePage}
                />
            );
        default:
            return null;
    }
};
